import React, { Fragment } from 'react';
import "./App.scss";
import Routes from './routes';
import { ClearBrowserCache } from 'react-clear-browser-cache';


function App() {
  return (
    <Fragment>
      <Routes />
        <ClearBrowserCache>{(contextValue) => null}</ClearBrowserCache>;
    </Fragment>

  );
}

export default App;
